import * as React from 'react';
import { Form } from 'semantic-ui-react';

import { DineroInput } from 'src/componentes';
import Panel from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Panel';
import { Datos as AlumnosDatos } from '../../S3Alumnos';
import IdentificacionContrato from './IdentificacionContrato';
import Pendiente, { Datos as PendienteDatos, inicial as pendienteInicial } from './Pendiente';

export interface Datos {
    pendiente: PendienteDatos;
}

export const inicial: Datos = {
    pendiente: { ...pendienteInicial },
};

export interface Props {
    readonly gastoNotarial: Datos;
    readonly todosLosAlumnos: ReadonlyArray<AlumnosDatos['alumnoPrincipal']>;
    onChange(gastoNotarial: Datos): void;
    alCambiarMontos(abonoInicial: number, indiceAlumno: number): void;
}

const GastosNotariales = (props: Props) => {
    const { gastoNotarial, todosLosAlumnos, onChange, alCambiarMontos } = props;

    return (
        <Panel titulo='Cuota de incorporación'>
            {todosLosAlumnos.map((alumno, index) => (
                <Form.Field key={index} width='8'>
                    <label>
                        <IdentificacionContrato alumno={alumno} numero={index + 1} />
                    </label>
                    <DineroInput
                        monto={alumno.montoGastoNotarial}
                        alCambiarMonto={monto => {
                            alCambiarMontos(monto, index);
                        }}
                    />
                </Form.Field>
            ))}

            <Form.Field width='8'>
                <label>Total</label>
                <DineroInput
                    soloLectura
                    monto={todosLosAlumnos.reduce((acc, alu) => acc + alu.montoGastoNotarial, 0)}
                />
            </Form.Field>

            <Pendiente
                ancho='3'
                datos={gastoNotarial.pendiente}
                onChange={pendiente => onChange({ ...gastoNotarial, pendiente })}
            />
        </Panel>
    );
};

export default GastosNotariales;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/GastosNotariales.tsx